import { render, staticRenderFns } from "./Welecom.vue?vue&type=template&id=019cc117&scoped=true&"
import script from "./Welecom.vue?vue&type=script&lang=js&"
export * from "./Welecom.vue?vue&type=script&lang=js&"
import style0 from "./Welecom.vue?vue&type=style&index=0&id=019cc117&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019cc117",
  null
  
)

export default component.exports